import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { LanguageSwitcher } from '../LanguageSwitcher';

export const AuthLayout = observer(() => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        bgcolor: 'white',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {/* Always-visible language switch, top-end corner (matches Keycloak login) */}
      <Box sx={{ position: 'fixed', top: 16, insetInlineEnd: 16, zIndex: 1000 }}>
        <LanguageSwitcher />
      </Box>

      <Outlet />
    </Box>
  );
});
